import { render, staticRenderFns } from "./IconWrapper.vue?vue&type=template&id=11b0442a&"
import script from "./IconWrapper.vue?vue&type=script&lang=ts&"
export * from "./IconWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports